export enum FuhFumTypeEnum {
    FUHDescription = 'FUH',
    FUH = 1,
    FUMDescription = 'FUM',
    FUM = 2,
    PCRDescription = 'PCR',
    PCR = 3,
}
